import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { api } from "../lib/api";
import { BackgroundTexture } from "../components/BackgroundTexture";
import { Footer } from "../components/Footer";

export default function GalleryPage() {
  const [gallery, setGallery] = useState([]);
  const [settings, setSettings] = useState(null);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    Promise.all([api.getGallery(), api.getSettings()])
      .then(([g, s]) => { setGallery(g.data); setSettings(s.data); })
      .catch(console.error);
  }, []);

  return (
    <div data-testid="gallery-page" className="min-h-screen content-layer">
      <BackgroundTexture />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-8 lg:py-12 relative z-10">
        <div className="mb-8">
          <p className="text-[11px] font-medium tracking-[0.15em] text-white/60 uppercase mb-2">Moments</p>
          <h1 className="font-syne text-3xl lg:text-4xl font-semibold text-white">Gallery</h1>
        </div>

        {gallery.length === 0 ? (
          <p className="text-white/60 py-20 text-center">Gallery coming soon.</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 lg:gap-4">
            {gallery.map((item) => (
              <div key={item.id} onClick={() => setSelected(item)} className="aspect-square overflow-hidden rounded-md cursor-pointer">
                <img src={item.image_url} alt="" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
              </div>
            ))}
          </div>
        )}
      </div>

      <AnimatePresence>
        {selected && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={() => setSelected(null)} className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4">
            <button onClick={() => setSelected(null)} className="absolute top-6 right-6 text-white/70 hover:text-white"><X size={28} /></button>
            <img src={selected.image_url} alt="" className="max-w-full max-h-[90vh] object-contain" />
          </motion.div>
        )}
      </AnimatePresence>
      <Footer settings={settings} />
    </div>
  );
}
